/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M3.5 1.75C1.9812 1.75.75 2.9812.75 4.5v10c0 1.5188 1.2312 2.75 2.75 2.75h7.75v4H6.5a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5h-4.75v-4h7.75c1.5188 0 2.75-1.2312 2.75-2.75v-10c0-1.5188-1.2312-2.75-2.75-2.75h-17ZM2.25 4.5c0-.6904.5596-1.25 1.25-1.25h17c.6904 0 1.25.5596 1.25 1.25v10c0 .6904-.5596 1.25-1.25 1.25h-17c-.6904 0-1.25-.5596-1.25-1.25v-10ZM5 4.75a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5H5Z"
    clipRule="evenodd"
  />,
  'LocalDev'
);
